import { Link } from "react-router-dom";
import logo from "@/assets/logo-jobteen.png";
import gouvcheck from "@/assets/gouvcheck-jobteen.png";
import { COMPANY } from "@/config/company";

const linkClass =
  "text-muted-foreground hover:text-foreground transition-colors duration-200 inline-flex items-center min-h-[44px] sm:min-h-0 justify-center sm:justify-start";

const columns = [
  {
    title: "Navigation",
    links: [
      { to: "/offres", label: "Offres d'emploi" },
      { to: "/a-propos", label: "À propos" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Espaces",
    links: [
      { to: "/espace-etudiant", label: "Espace Étudiant" },
      { to: "/espace-recruteur", label: "Espace Recruteur" },
    ],
  },
  {
    title: "Légal & Contact",
    links: [
      { to: "/mentions-legales", label: "Mentions légales" },
      { to: "/confidentialite", label: "Politique de confidentialité" },
      { to: "/cgu", label: "Conditions d'utilisation" },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="border-t border-border/70 bg-background">
      <div className="container py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="text-center sm:text-left">
            <Link to="/" className="inline-block group">
              <img
                src={logo}
                alt="Logo JobTeen – Plateforme d'emploi pour les jeunes au Luxembourg"
                className="h-14 md:h-16 w-auto mx-auto sm:mx-0 transition-opacity duration-200 group-hover:opacity-80"
                width={281}
                height={72}
              />
            </Link>
            <p className="mt-5 text-sm font-medium text-foreground">JobTeen — Jobs pour les jeunes au Luxembourg</p>
            <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
              La plateforme européenne qui connecte les étudiants aux opportunités locales.
            </p>
            <p className="mt-3 text-xs text-muted-foreground leading-relaxed">
              {COMPANY.legalName}<br />
              {COMPANY.streetAddress}, {COMPANY.postalCode} {COMPANY.locality}
            </p>
          </div>

          {columns.map((column) => (
            <div key={column.title} className="text-center sm:text-left">
              <p className="type-eyebrow">{column.title}</p>
              <ul className="mt-5 space-y-2 sm:space-y-3 text-sm">
                {column.links.map((link) => (
                  <li key={link.to} className="flex sm:block justify-center">
                    <Link to={link.to} className={linkClass}>
                      {link.label}
                    </Link>
                  </li>
                ))}
                {column.title === "Légal & Contact" && (
                  <li className="flex sm:block justify-center">
                    <a href={`mailto:${COMPANY.email}`} className={linkClass}>
                      Support
                    </a>
                  </li>
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-7 border-t border-border/70 flex flex-col md:flex-row justify-between items-center gap-6 text-[13px] text-muted-foreground text-center">
          <div className="space-y-1">
            <p>© 2025 JobTeen. Tous droits réservés.</p>
            <p>Données hébergées en Europe 🇪🇺</p>
          </div>

          <div className="flex items-center gap-4">
            <div className="text-center sm:text-left">
              <p className="text-sm font-medium text-foreground">Autorisation d’établissement</p>
              <p className="mt-0.5">N° {COMPANY.establishmentPermit}</p>
            </div>
            <div className="shrink-0 rounded-[var(--radius-xs)] bg-white p-1.5">
              <img
                src={gouvcheck}
                alt="QR GouvCheck de l’autorisation d’établissement JobTeen"
                width={90}
                height={90}
                loading="lazy"
                className="h-auto w-[80px] sm:w-[90px] max-w-[90px] object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
